import { render, staticRenderFns } from "./ProfileAddresses.vue?vue&type=template&id=5c7a5e30&scoped=true"
import script from "./ProfileAddresses.vue?vue&type=script&lang=js"
export * from "./ProfileAddresses.vue?vue&type=script&lang=js"
import style0 from "./ProfileAddresses.vue?vue&type=style&index=0&id=5c7a5e30&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c7a5e30",
  null
  
)

export default component.exports